import { Grid, styled } from '@mui/material'
import { useTranslation } from 'react-i18next'
import DatePicker, { DatePickerClearButton, RoundMode } from '../DatePicker'

export const DATETIME_RANGE_MINUTES_STEP = 15

const FieldWrapper = styled(Grid)(({ theme }) => ({
  gap: theme.spacing(2),
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(1),
}))

const DateFieldWrapper = styled(Grid)(({ theme }) => ({
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
  gap: theme.spacing(1),
}))

export interface DateTimeRangeFieldsProps {
  start: Date | null
  end: Date | null
  startErrorMessage?: string
  endErrorMessage?: string
  disabled?: boolean
  startLabel: string
  endLabel: string
  minutesStep?: number
  onStartChange: (value: Date | null) => void
  onEndChange: (value: Date | null) => void
}

export function DateTimeRangeFields({
  start,
  end,
  startErrorMessage,
  endErrorMessage,
  disabled = false,
  startLabel,
  endLabel,
  minutesStep = DATETIME_RANGE_MINUTES_STEP,
  onStartChange,
  onEndChange,
}: DateTimeRangeFieldsProps) {
  const { t } = useTranslation()
  const clearLabel = t('clear')
  const step = {
    minutesStep,
    roundMode: RoundMode.Up,
  }

  return (
    <FieldWrapper container>
      <DateFieldWrapper item container>
        <Grid item xs={12} md={9}>
          <DatePicker
            label={startLabel}
            errorMessage={startErrorMessage}
            revalidateFunc={async () => {}}
            showTime
            disabled={disabled}
            onChange={onStartChange}
            value={start}
            onBlur={() => {}}
            step={step}
          />
        </Grid>
        <DatePickerClearButton
          fullWidth={false}
          label={clearLabel}
          disabled={disabled}
          onClick={async () => {
            if (!disabled) onStartChange(null)
          }}
        />
      </DateFieldWrapper>
      <DateFieldWrapper container>
        <Grid item xs={12} md={9}>
          <DatePicker
            label={endLabel}
            errorMessage={endErrorMessage}
            revalidateFunc={async () => {}}
            showTime
            disabled={disabled}
            onChange={onEndChange}
            value={end}
            onBlur={() => {}}
            step={step}
          />
        </Grid>
        <DatePickerClearButton
          fullWidth={false}
          disabled={disabled}
          label={clearLabel}
          onClick={async () => {
            if (!disabled) onEndChange(null)
          }}
        />
      </DateFieldWrapper>
    </FieldWrapper>
  )
}

export default DateTimeRangeFields
